import z from 'zod'

export const ErrorSchema = z.object({
  result: z.boolean(),
  exceptionDetail: z.string().nullable(),
  code: z
    .union([
      z.literal(1), // Success
      z.literal(2), // SystemError
      z.literal(3), // UserError
    ])
    .optional(),
})

export type Error = z.infer<typeof ErrorSchema>
